import { render, staticRenderFns } from "./certificateAuthenticationModal.vue?vue&type=template&id=63a88bc6&scoped=true&"
import script from "./certificateAuthenticationModal.vue?vue&type=script&lang=js&"
export * from "./certificateAuthenticationModal.vue?vue&type=script&lang=js&"
import style0 from "./certificateAuthenticationModal.vue?vue&type=style&index=0&id=63a88bc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a88bc6",
  null
  
)

export default component.exports